import React, { useEffect } from 'react';
import WithLoading from '../../../Hoc/WithLoading';
import VoucherOrderDetailView from './VoucherOrderDetailView';
import { getOrderApi } from '../Detail/OrderDetail';

const VoucherOrderDetail = ({ id }) => {
  useEffect(() => {}, [id]);
  return (
    <WithLoading
      component={VoucherOrderDetailView}
      url={getOrderApi.replace(':id', id)}
    />
  );
};

export default React.memo(VoucherOrderDetail);
